import { Row, Col, Statistic } from 'antd';
import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';

const AccountBalance = ({ investmentAccounts }) => {
  const { lang } = useLanguage(translations);

  const latestBalance = investmentAccounts?.latestBalance || 0;

  return (
    <>
      <Row gutter={16}>
        <Col span={24}>
          <Statistic title={lang('accountBalance')} value={latestBalance} prefix="$" />
        </Col>
      </Row>
      {latestBalance === 0 && (
        <Row gutter={16} style={{ marginTop: '10px' }}>
          <Col span={24}>
            <p style={{ color: 'gray' }}>{lang('depositStatus')}</p>
          </Col>
        </Row>
      )}
    </>
  );
};

export default AccountBalance;
